import React, { memo, useMemo } from 'react';
import OrgTrendsChart from './OrgTrendsChart';
import { getTrendSeriesForChart } from 'js/utils/org-trends';
import { buildOrgTrendsChartLines } from 'js/utils/org-trends-rollup';
import { createOrgAssessmentWeightContext } from 'js/utils/org-assessment-rollup';
import { useOrgTrends } from './OrgTrendsContext';

import styles from './OrgTrends.module.scss';

function Question({
  label,
  retired = false,
  teams,
  window,
  seriesKey,
  lineHoverMaxDistance,
}) {
  const { organization, selectedPickerRow, debounceTrendPoints } =
    useOrgTrends();

  const weightContext = useMemo(
    () => createOrgAssessmentWeightContext(organization),
    [organization]
  );

  const lines = useMemo(
    () =>
      buildOrgTrendsChartLines({
        organization,
        teams,
        weightContext,
        selectedPickerRow,
        getTeamSeries: (series) => series?.questions?.[seriesKey],
        getTrendSeriesForChart,
        window,
        debounceTrendPoints,
      }),
    [
      debounceTrendPoints,
      organization,
      selectedPickerRow,
      seriesKey,
      teams,
      weightContext,
      window,
    ]
  );

  if (!lines.length) {
    return null;
  }

  return (
    <div className={styles.question}>
      <div className={styles['question-text']}>
        <span>{label}</span>
        {retired && <span className={styles.retiredBadge}>Retired</span>}
      </div>
      <div className={styles['chart-wrapper']}>
        <OrgTrendsChart
          window={window}
          trendLines={lines}
          lineHoverMaxDistance={lineHoverMaxDistance}
        />
      </div>
    </div>
  );
}

export default memo(Question);
